import React, {Component} from 'react';
import PropTypes from 'prop-types';

class SVGDefinitions extends Component {
    static propTypes = {
        /** GraphQL Data for SVG Definitions */
        data: PropTypes.shape({
            loading: PropTypes.bool,
            svgs: PropTypes.objectOf(PropTypes.string)
        }).isRequired
    }

    static defaultProps = {
        data: {
            svgs: {}
        }
    }

    joinDefinitions() {
        const {svgs} = this.props.data;
        let definitions = '';

        for (const def in svgs) {
            if (svgs.hasOwnProperty(def)) {
                definitions += svgs[def];
            }
        }

        return {__html: definitions};
    }

    render() {
        return (
            <svg width="0" height="0" style={{'display': 'none'}} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                {!this.props.data.loading &&
                    <defs dangerouslySetInnerHTML={this.joinDefinitions()}/> // eslint-disable-line react/no-danger
                }
                <defs>
                    {this.props.children}
                </defs>
            </svg>
        );
    }
}

export default SVGDefinitions;
